import { useTranslation } from 'react-i18next'

import { SectionHeader } from 'components/Header'
import Paper from 'components/Paper'
import { useAbility } from 'providers/casl'
import { EmployeeSettingsSection } from './EmployeeSettingsSection'

export const KWordsSection = (): React.JSX.Element => {
  const { t } = useTranslation('features/globalSetup', {
    keyPrefix: 'defaults.richPlacements.kWords',
  })

  const ability = useAbility()
  const canReadSiteId: boolean = ability.can('read', 'GlobalSetupField-kWordsSiteId')

  return (
    <>
      <Paper
        data-cy='section-k-words'
        sx={{ mt: 0 }}
      >
        <SectionHeader
          subtitle={t('description')}
          title={t('title')}
        />
      </Paper>

      {canReadSiteId && <EmployeeSettingsSection />}
    </>
  )
}
